import * as React from 'react';
import {Link} from 'react-router-dom';

import {Routing} from 'nutshell-core/routing';

import styles from './cell.module.css';

type LinkedLeadDateValue = {
    value: string;
    absoluteLocalizedString: string;
    timestamp: number;
    lead: {
        id: string;
        htmlUrl: string;
    };
};

type Props = {
    value:
        | {
              value: LinkedLeadDateValue;
          }
        | null
        | undefined;
};

export function CellLinkedLeadDate(props: Props) {
    if (!props.value || !props.value.value || !props.value.value.value) {
        return null;
    }

    // The API wraps the value, so we need to unwrap it
    const {value, absoluteLocalizedString, lead} = props.value.value;

    const handleClick = (e: React.SyntheticEvent) => {
        e.stopPropagation();
    };

    const dateContent = <span title={absoluteLocalizedString}>{value}</span>;

    if (!lead || !lead.htmlUrl) {
        return <div className={styles['cell-content']}>{dateContent}</div>;
    }

    return (
        <div className={styles['cell-content']}>
            {Routing.hasWorkingUrl() ? (
                // @ts-expect-error
                <Link
                    to={lead.htmlUrl}
                    onClick={handleClick}
                    className={styles['linked-lead-date']}
                >
                    {dateContent}
                </Link>
            ) : (
                <a href={lead.htmlUrl} onClick={handleClick} className={styles['linked-lead-date']}>
                    {dateContent}
                </a>
            )}
        </div>
    );
}
